import React from 'react';
import '../../../styles/modal.css';
import RequirementUploadForm from '../RequirementUploadForm';

const RequirementUploadModal = ({ isOpen, onClose, project }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div data-rt-modal-overlay className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) { const b = e.currentTarget.querySelector('[data-rt-modal-close], .close-btn, .modal-close, button[aria-label="Close"], button[aria-label="close"]'); if (b) b.click(); } }}>
      <div className="modal-container">
        <div className="modal-header">
          <h2>Upload Requirements for {project ? project.name : 'Project'}</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            type="button"
          >
            ×
          </button>
        </div>
        <RequirementUploadForm
          project={project}
          variant="modal"
          onCancel={onClose}
          onSuccess={onClose}
        />
      </div>
    </div>
  );
};

export default RequirementUploadModal;
